<div class="protocols-container">

    <!-- HEADER -->
    <div class="page-head d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
            <h4 class="text-teal fw-bold d-flex align-items-center gap-2">
                <i class="bi bi-diagram-3"></i>
                My Protocols
            </h4>
            <small class="text-muted">
                <i class="bi bi-info-circle me-1"></i>
                Manage your treatment plans
            </small>
        </div>
    </div>

    <!-- 🔥 STATS -->
    <div class="stats-row mt-3">

        <div class="stat-card">
            <div class="icon">
                <i class="bi bi-collection"></i>
            </div>
            <div class="value">{{ protocols.length }}</div>
            <div class="label">Total Protocols</div>
        </div>

        <div class="stat-card active">
            <div class="icon">
                <i class="bi bi-check-circle"></i>
            </div>
            <div class="value">{{ getCount('ACTIVE') }}</div>
            <div class="label">Active</div>
        </div>

        <div class="stat-card due">
            <div class="icon">
                <i class="bi bi-clock-history"></i>
            </div>
            <div class="value">{{ getDueSoonCount() }}</div>
            <div class="label">Due Soon</div>
        </div>

    </div>

    <!-- FILTER -->
    <div class="filters-card mt-3">
        <div class="row g-2 align-items-end">

            <div class="col-md-3">
                <label class="small text-muted">
                    <i class="bi bi-funnel"></i> Status
                </label>

                <select class="form-select form-select-sm" [(ngModel)]="query.status" (change)="applyFilters()">

                    <option *ngFor="let s of statusOptions" [value]="s.value">
                        {{ s.label }}
                    </option>

                </select>
            </div>

        </div>
    </div>

    <!-- LOADING -->
    <div *ngIf="loading" class="text-center p-4">
        <i class="bi bi-arrow-repeat spin"></i> Loading protocols...
    </div>

    <!-- EMPTY -->
    <div *ngIf="!loading && protocols.length === 0" class="empty-state">
        <i class="bi bi-inbox"></i>
        <p>No protocols found</p>
    </div>

    <!-- CARDS -->
    <div class="protocol-grid mt-3" *ngIf="!loading && protocols.length">

        <div class="protocol-card" *ngFor="let p of protocols">

            <!-- HEADER -->
            <div class="card-head">

                <div class="fw-semibold">
                    {{ p.templateSnapshot?.name }}
                </div>

                <span class="status-pill" [ngClass]="p.status.toLowerCase()">
                    {{ p.status }}
                </span>

            </div>

            <!-- 🔥 DUE BADGE -->
            <div *ngIf="isDueSoon(p.nextDueDate)" class="due-badge">
                ⚠ Due Soon
            </div>

            <!-- BODY -->
            <div class="card-body">

                <div class="row-item">
                    <label><i class="bi bi-calendar"></i> Start</label>
                    <span>{{ p.startDate | date:'mediumDate' }}</span>
                </div>

                <div class="row-item">
                    <label><i class="bi bi-clock-history"></i> Next Due</label>
                    <span>{{ p.nextDueDate | date:'mediumDate' }}</span>
                </div>

                <div class="row-item">
                    <label><i class="bi bi-arrow-repeat"></i> Frequency</label>
                    <span>{{ p.frequencyMonths }} months</span>
                </div>

                <!-- 🔥 PROGRESS -->
                <div class="progress-wrap mt-2">
                    <div class="progress">
                        <div class="progress-inner" [style.width.%]="getProgress(p)">
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

    <!-- PAGINATION -->
    <div class="pagination mt-3 text-center" *ngIf="pages.length > 1">

        <button *ngFor="let p of pages" [class.active]="p === query.page" (click)="goToPage(p)">
            {{ p }}
        </button>

    </div>

</div>